import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import NavbarItem from './navbar-item/index.js';
import { MDTApp } from '../../../../../../actions/bootAction.js';

import './navbar.css';

const Navbar = (props) => {
  const { t, loggedIn, menuOpen, showLevel0, setShowLevel0, setMenuOpen } = props;
  const sidebar = window.MDTSetting.layout.sidebar || {};
  const [appId] = useState(MDTApp.getSetting('appid'));
  const [isExpanded, setIsExpanded] = useState(null);
  const [menuLevel0, setMenuLevel0] = useState(false);

  const toggleMenu = (flag, fromMenu = true) => {
    if (props.toggleFunc) {
      props.toggleFunc(flag, fromMenu);
    }
  };

  const setDefaultState = () => {
    setIsExpanded(null);
  };

  useEffect(() => {
    setMenuLevel0(showLevel0);
  }, [showLevel0]);

  useEffect(() => {
    setDefaultState();
  }, [isExpanded]);

  const handleMouseLeave = () => {
    //update the state to default value so in child component you can receive new props
    setIsExpanded(false);
  };

  return (
    <nav
      className={`mdt-navbar ${appId} ${menuLevel0 ? 'open' : ''}`}
      role="navigation"
      aria-label="Main Navigation"
      onMouseLeave={() => {
        handleMouseLeave();
      }}
      data-test={`${loggedIn ? 'logged-in' : 'unauthorised'}`}
    >
      {loggedIn && (
        <NavbarItem
          t={t}
          expanded={isExpanded}
          layoutConfig={sidebar.main}
          toggleMenu={toggleMenu}
          loggedIn={loggedIn}
          className="main"
          setShowLevel0={setShowLevel0}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />
      )}
      {!loggedIn && (
        <NavbarItem
          t={t}
          expanded={isExpanded}
          layoutConfig={sidebar.guest}
          toggleMenu={toggleMenu}
          loggedIn={loggedIn}
          className="main"
          setShowLevel0={setShowLevel0}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />
      )}
      {loggedIn && (
        <NavbarItem
          t={t}
          expanded={isExpanded}
          layoutConfig={sidebar.secondary}
          toggleMenu={toggleMenu}
          loggedIn={loggedIn}
          className="secondary"
          setShowLevel0={setShowLevel0}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />
      )}
    </nav>
  );
};

export default connect()(Navbar);
